import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { ChartWrapper } from '../../components';

const mapStateToProps = state => {
  return {
    chart: state.results.chart,
  }
}

const mapDispatchToProps = dispatch => {
  return {
  }
}

export const ChartWrapperContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(ChartWrapper);


// WEBPACK FOOTER //
// ./src/containers/ChartWrapper/ChartWrapperContainer.js